// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   Cover Editor V2
═══════════════════════════════════════════════ */
.cover-editor-v2 {
  display: flex;
  gap: 24px;
  width: 100%;
  min-height: 520px;
  align-items: flex-start;
}

/* ── Left controls panel ── */
.cover-controls-panel {
  width: 272px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 700px;
  overflow-y: auto;
  padding-right: 2px;
}

.cover-section {
  background: #f8fafc;
  border: 1px solid #d9e1ea;
  border-radius: 16px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.cover-section-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #738194;
  font-weight: 800;
  font-family: 'Montserrat', Arial, sans-serif;
}

/* ── Rail + single-open-panel layout (replaces the old all-sections-stacked
   layout) - one of Text/Layout/Stickers open at a time, like Pixory. ── */
.cover-controls-tabbed {
  flex-direction: row;
  gap: 0;
  padding: 0;
  overflow: hidden;
}

.cover-rail {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 60px;
  flex-shrink: 0;
  padding: 10px 6px;
  border-right: 1px solid #d9e1ea;
  background: #f8fafc;
}

.cover-rail-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  background: none;
  border: none;
  border-radius: 10px;
  padding: 8px 2px;
  cursor: pointer;
  color: #738194;
  font-family: 'Montserrat', Arial, sans-serif;
  transition: background 0.15s, color 0.15s;
}
.cover-rail-btn:hover { background: #eef2f7; }
.cover-rail-btn.active { background: #2d3748; color: #fff; }

.cover-rail-icon { font-size: 16px; font-weight: 700; line-height: 1; }
.cover-rail-label { font-size: 9px; font-weight: 700; text-align: center; line-height: 1.15; }

.cover-panel-body {
  flex: 1 1;
  min-width: 0;
  padding: 14px;
  overflow-y: auto;
  max-height: 700px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

/* ── Stickers panel (in CoverControls) ── */
.cover-sticker-cats {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cover-sticker-cat {
  background: #fff;
  border: 1px solid #d9e1ea;
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #445064;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.cover-sticker-cat:hover { background: #eef2f7; }
.cover-sticker-cat.active {
  background: #2d3748;
  border-color: #2d3748;
  color: #fff;
}

.cover-stickers-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
}

.cover-sticker-thumb {
  aspect-ratio: 1;
  background: #fff;
  border: 1px solid #d9e1ea;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.cover-sticker-thumb:hover {
  border-color: #ef6d49;
  background: #fff7f4;
}
.cover-sticker-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}

/* ── Mode buttons ── */
.cover-mode-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.cover-mode-btn {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 11px 13px;
  background: #fff;
  border: 1px solid #c8d2dd;
  border-radius: 12px;
  color: #233042;
  font-size: 13.5px;
  font-family: 'Montserrat', Arial, sans-serif;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.18s, background 0.18s;
  line-height: 1.2;
}

.cover-mode-btn:hover { border-color: #2d3748; }

.cover-mode-btn.active {
  border-color: #2d3748;
  background: #ffffff;
  color: #2d3748;
  font-weight: 700;
}

.cover-mode-btn.has-badge { padding-top: 17px; align-items: flex-end; }

.cover-btn-label { flex: 1 1; }

.cover-mode-badge {
  position: absolute;
  top: -10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #d92d20;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
}

/* ── Form fields ── */
.cover-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cover-field label {
  font-size: 11.5px;
  color: #738194;
  font-weight: 600;
  font-family: 'Montserrat', Arial, sans-serif;
}

.cover-field input[type="text"],
.cover-field select {
  padding: 8px 11px;
  border: 1px solid #c8d2dd;
  border-radius: 10px;
  font-size: 13px;
  color: #233042;
  background: #fff;
  outline: none;
  transition: border-color 0.18s;
}

.cover-field input[type="text"]:focus,
.cover-field select:focus {
  border-color: #2d3748;
  box-shadow: 0 0 0 3px rgba(45, 55, 72, 0.1);
}

.cover-field input[type="range"] {
  width: 100%;
  accent-color: #2d3748;
  cursor: pointer;
  margin-top: 1px;
}

.cover-color-row {
  display: flex;
  align-items: center;
  gap: 9px;
}

.cover-color-row input[type="color"] {
  width: 36px;
  height: 34px;
  padding: 2px;
  border: 1px solid #c8d2dd;
  border-radius: 9px;
  cursor: pointer;
  background: #fff;
}

.cover-color-hex {
  font-size: 11px;
  color: #738194;
  font-family: monospace;
}

/* ── Side tabs (Para / Mbrapa) ── */
.cover-side-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.cover-side-tab {
  padding: 9px 10px;
  background: #fff;
  border: 1px solid #c8d2dd;
  border-radius: 10px;
  color: #233042;
  font-size: 13px;
  font-family: 'Montserrat', Arial, sans-serif;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.18s, background 0.18s;
}

    .cover-side-tab:hover { border-color: #2d3748; }

.cover-side-tab.active {
  border-color: #2d3748;
  background: #ffffff;
  color: #2d3748;
  font-weight: 700;
}

/* ── Layout buttons (1 foto / 4 foto) ── */
.cover-layout-btns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;
}

.cover-layout-btn {
  border: 1px solid #c8d2dd;
  background: #fff;
  border-radius: 12px;
  padding: 10px 8px;
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  transition: border-color 0.18s, background 0.18s;
}

.cover-layout-btn:hover { border-color: #2d3748; background: #dfdfdf; }

.cover-layout-btn.active {
  border-color: #2d3748;
  background: #ffffff;
}

.cover-layout-btn span {
  font-size: 12px;
  color: #233042;
  font-family: 'Montserrat', Arial, sans-serif;
}

.cover-layout-btn.active span { color: #2d3748; font-weight: 700; }

.layout-icon-box {
  width: 44px;
  height: 44px;
  border: 1px solid rgba(35, 48, 66, 0.14);
  border-radius: 9px;
  background: #f3f6f9;
  display: grid;
  place-items: center;
  overflow: hidden;
  position: relative;
}

/* Full = single block */
.layout-icon-preview.full {
  width: 30px;
  height: 30px;
  background: rgba(35, 48, 66, 0.2);
  border-radius: 3px;
}

/* Grid = 2×2 */
.layout-icon-preview.grid {
  width: 30px;
  height: 30px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 2px;
}

.layout-icon-preview.grid::before,
.layout-icon-preview.grid::after {
  content: '';
  display: block;
  background: rgba(35, 48, 66, 0.2);
  border-radius: 2px;
}

/* Extra 2 cells for grid via box-shadow trick */
.layout-icon-preview.grid {
  background:
    linear-gradient(rgba(35,48,66,0.2) 0 100%) 0 0 / 13px 13px no-repeat,
    linear-gradient(rgba(35,48,66,0.2) 0 100%) 16px 0 / 13px 13px no-repeat,
    linear-gradient(rgba(35,48,66,0.2) 0 100%) 0 16px / 13px 13px no-repeat,
    linear-gradient(rgba(35,48,66,0.2) 0 100%) 16px 16px / 13px 13px no-repeat;
}

.layout-icon-preview.grid::before,
.layout-icon-preview.grid::after { display: none; }

/* Full-bleed icon = full block filling the icon box */
.layout-icon-preview.full-bleed {
  width: 38px;
  height: 38px;
  background: rgba(35, 48, 66, 0.2);
  border-radius: 2px;
}

/* ── Action buttons ── */
.cover-action-btn {
  width: 100%;
  padding: 10px 13px;
  background: #fff;
  border: 1px solid #c8d2dd;
  border-radius: 12px;
  color: #233042;
  font-size: 13px;
  font-family: 'Montserrat', Arial, sans-serif;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.18s, transform 0.12s;
}

.cover-action-btn:hover { border-color: #2d3748; transform: translateY(-1px); }

.cover-action-btn.secondary { color: #738194; }
.cover-action-btn.secondary:hover { border-color: #2d3748; color: #2d3748; }

.cover-upload-group { display: flex; flex-direction: column; gap: 7px; }

/* ═══════════════════════════════════════════════
   Right preview panel
═══════════════════════════════════════════════ */
.cover-preview-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-width: 0;
  padding: 10px 0;
}

.cover-spread-wrap {
  display: flex;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.14);
  border-radius: 4px;
  overflow: hidden;
}

/* Cover page — 33:48 ratio ≈ 220×315 */
.cover-page {
  position: relative;
  width: 220px;
  height: 315px;
  overflow: hidden;
  flex-shrink: 0;
}

/* Wrapper që mban barin e jashtëm + cover page bashkë */
.cover-page-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

/* .cover-back { border-right: 2px solid rgba(0, 0, 0, 0.1); } */

/* ── Shpina (mes kopertinës së pasme dhe të përparme) — vetëm pamje
   paraprake, shih shënimin te CoverEditor.js pranë renderimit të saj. ── */
.cover-spine-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Pa gap: spineTopOffset (matur me JS) është VETË distanca e plotë
     deri te maja e faqes — nëse shtojmë edhe gap këtu, e dyfishojmë
     boshllëkun dhe shpina bie 6px më poshtë se faqet. */
  gap: 0;
  flex-shrink: 0;
}

.cover-spine-bar-spacer {
  height: 34px; /* fallback derisa CoverEditor.js ta llogarisë saktë me JS (ResizeObserver) */
}

.cover-spine {
  position: relative;
  width: 18px;
  height: min(65vh, 520px);
  box-shadow: inset 2px 0 0 rgba(0, 0, 0, 0.06), inset -2px 0 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* Dy tekste të pavarura në shpinë — titulli afër majës, data afër fundit —
   të dyja vertikale (rrotulluar), të centruara horizontalisht në shirit. */
.cover-spine-text {
  position: absolute;
  left: 50%;
  display: inline-block;
  white-space: nowrap;
  transform: translate(-50%, -50%) rotate(90deg);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cover-spine-text-title { top: 12%; }
.cover-spine-text-date  { top: 88%; }

/* Spine sticker: single static slot (no drag/resize) - click to add (empty
   dashed placeholder) or click again to remove (the placed icon itself is
   the delete affordance, since .cover-spine's \`overflow: hidden\` at ~16px
   wide leaves no room for a separate corner delete badge). */
.cover-spine-sticker {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  border-radius: 2px;
  transition: opacity 0.15s, outline 0.15s;
  outline: 1.5px solid transparent;
  outline-offset: 1px;
}
.cover-spine-sticker:hover {
  opacity: 0.55;
  outline-color: #e53e3e;
}

.cover-spine-sticker img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  pointer-events: none;
}

.cover-spine-sticker-add {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px dashed #b7c1cd;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.6);
  color: #738194;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  z-index: 4;
}
.cover-spine-sticker-add:hover {
  border-color: #ef6d49;
  color: #ef6d49;
  background: #fff;
}

.cover-spine-note {
  font-size: 11px;
  color: #9aa5b1;
  margin: 2px 0 0;
  line-height: 1.4;
}

.cover-full-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  z-index: 1;
}

/* ─── Photo area container ─── */
.cover-photo-area {
  position: absolute;
  overflow: hidden;
  z-index: 2;
}

/* Single photo: rectangle in upper portion */
.cover-photo-area.full {
  top: 5%;
  left: 6%;
  right: 6%;
  height: 60%;
}

/* Full-bleed: photo covers entire cover page */
.cover-photo-area.full-bleed {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

/* 4-photo grid: same zone as single photo, 2x2 layout */
.cover-photo-area.grid-4 {
  top: 5%;
  left: 6%;
  right: 6%;
  height: 60%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 8px;
}

/* Grid-4 cells */
.cover-photo-area.grid-4 .csw-content {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.04);
}

/* Photos fit fully — no cropping, no auto-zoom */
.cover-photo-area.grid-4 .csw-img {
  object-fit: contain;
}

/* ─── CoverPhotoSlot (csw = cover slot wrap) ─────────────────────────────── */
.csw {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: visible;
}


/* Control bar — brenda slot (vetëm mini/grid-4) */
.csb-bar {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 2px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 999px;
  padding: 4px 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
  z-index: 20;
  white-space: nowrap;
}

/* Bar i jashtëm — sipër cover page, jo brenda */
.csb-bar-external {
  position: static;
  transform: none;
  top: auto;
  left: auto;
}

.csw-mini .csb-bar {
  top: 4px;
  padding: 3px 7px;
  gap: 1px;
}

/* Mini delete-only bar: small × badge in top-right corner */
.csb-bar.csb-bar-mini-del {
  top: 4px;
  right: 4px;
  left: auto;
  transform: none;
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.csb {
  width: 26px;
  height: 26px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  color: #233042;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.12s;
  padding: 0;
}

.csw-mini .csb { width: 0px; height: 2px; font-size: 11px; }

.csb:hover { background: #f0f2f5; }
.csb.csb-dis { color: #c0cad5; cursor: default; }
.csb.csb-dis:hover { background: none; }
.csb.csb-del { color: #e53e3e; }
.csb.csb-del:hover { background: #fff5f5; }

/* Slot content area */
.csw-content {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  border-radius: 4px;
  position: relative;
}


.csw-content.csw-empty {
  border: 1.5px dashed rgba(202, 202, 202, 0.281);
  background: rgba(202, 202, 202, 0.622);
  transition: background 0.15s;
}

.csw-content.csw-empty:hover { background: rgba(202, 202, 202, 0.12); }

/* Image inside slot — absolutely fills the container so % height resolves correctly */
.csw-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform-origin: center center;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

/* Grid-4 photos: show full image without any cropping */
.cover-photo-area.grid-4 .csw-img {
  object-fit: contain;
}

/* Empty placeholder text */
.csw-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  pointer-events: none;
}

.csw-placeholder span:first-child { font-size: 22px; color: #ffffff; line-height: 1; }
.csw-placeholder span:last-child  { font-size: 7px; color: #ffffff; font-weight: 600; font-family: 'Montserrat', Arial, sans-serif; }

/* ── QR area ── */
.cover-qr-area {
  position: absolute;
  bottom: 26px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  z-index: 4;
}

.cover-qr-box {
  width: 46px;
  height: 46px;
  border: 1.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  background:
    repeating-linear-gradient(0deg, rgba(0,0,0,0.14) 0px, rgba(0,0,0,0.14) 3px, transparent 3px, transparent 6px),
    repeating-linear-gradient(90deg, rgba(0,0,0,0.14) 0px, rgba(0,0,0,0.14) 3px, transparent 3px, transparent 6px),
    rgba(255,255,255,0.95);
}


.cover-qr-label {
  font-size: 8px;
  color: rgba(0, 0, 0, 0.4);
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* ── Upload hint ── */
.cover-upload-hint {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  background: rgba(198, 198, 198, 0.14);
  border: 2px dashed rgba(198, 198, 198, 0.14);
  z-index: 3;
  transition: background 0.18s;
}

.cover-upload-hint:hover { background: rgba(198, 198, 198, 0.14); }
.cover-upload-hint span:first-child { font-size: 26px; color: #2d3748; line-height: 1; }
.cover-upload-hint span:last-child { font-size: 11px; color: #2d3748; font-weight: 700; font-family: 'Montserrat', Arial, sans-serif; }

/* ─── Large QR adjustment ─── */
.cover-page.large .cover-qr-area { bottom: 60px; }
.cover-page.large .cover-qr-box  { width: 60px; height: 60px; }

/* ── Draggable text overlays ── */
.cover-drag-text {
  z-index: 5;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  padding: 3px 6px;
  border-radius: 3px;
  transition: outline 0.15s;
  text-align: center;
}

.cover-drag-text:hover {
  outline: 1.5px dashed rgba(239, 109, 73, 0.6);
  outline-offset: 3px;
}

.cover-drag-text:active {
  cursor: grabbing;
  outline: 1.5px solid #2d3748;
}

.cover-drag-text-input {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  outline: 1.5px dashed rgba(239, 109, 73, 0.9);
  outline-offset: 3px;
  cursor: text;
}

/* ── Sticker overlays ── */
.cover-sticker {
  position: absolute;
  z-index: 6;
  cursor: grab;
  outline: 1.5px dashed transparent;
  outline-offset: 2px;
  transition: outline 0.15s;
}

.cover-sticker:hover {
  outline-color: rgba(239, 109, 73, 0.6);
}

.cover-sticker:active {
  cursor: grabbing;
}

.cover-sticker img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.cover-sticker-del {
  /* Top-CENTER, not a corner - all 4 corners are resize handles now, and
     top-right overlapped/blocked this button's clicks when it lived there
     too. */
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  font-size: 11px;
  z-index: 8;
}

.cover-sticker-handle {
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: #fff;
  border: 1.5px solid #2d3748;
  cursor: nwse-resize;
  z-index: 7;
}

.cover-sticker-handle-br { bottom: -6px; right: -6px; cursor: nwse-resize; }
.cover-sticker-handle-tl { top: -6px; left: -6px; cursor: nwse-resize; }
.cover-sticker-handle-tr { top: -6px; right: -6px; cursor: nesw-resize; }
.cover-sticker-handle-bl { bottom: -6px; left: -6px; cursor: nesw-resize; }

/* ── Page tag ── */
.cover-page-tag {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.48);
  color: #fff;
  font-size: 8.5px;
  padding: 2px 7px;
  border-radius: 999px;
  white-space: nowrap;
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.03em;
  z-index: 10;
  pointer-events: none;
}

.cover-preview-note {
  font-size: 11.5px;
  color: #8fa0b4;
  font-family: 'Montserrat', Arial, sans-serif;
  text-align: center;
  margin: 0;
}

/* ══════════════════════════════════════════════
   Large (stage) cover preview
══════════════════════════════════════════════ */
.cover-preview-stage {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
  padding: 16px 12px;
}

/* ── Popup udhëzues (një herë, kur klienti hyn te redaktimi i kopertinës) ── */
.cover-intro-overlay {
  position: absolute;
  inset: 0;
  background: rgba(20, 20, 25, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 60;
  border-radius: 8px;
  padding: 16px;
}

.cover-intro-card {
  background: #fff;
  border-radius: 14px;
  padding: 20px 22px;
  max-width: 320px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  text-align: left;
}

.cover-intro-card h4 {
  margin: 0 0 8px;
  font-size: 15px;
  color: #233042;
  font-family: 'Montserrat', Arial, sans-serif;
}

.cover-intro-card p {
  margin: 0 0 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #5b6774;
  font-family: 'Montserrat', Arial, sans-serif;
}

.cover-intro-close {
  width: 100%;
  padding: 10px 12px;
  background: #2d3748;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  font-family: 'Montserrat', Arial, sans-serif;
  cursor: pointer;
}

.cover-intro-close:hover { background: #1a202c; }

.cover-spread-large {
  display: flex;
  flex-direction: row;
  gap: 1px;
  justify-content: center;
  align-items: flex-start;
}

/* Large cover page: scales with viewport */
.cover-page.large {
  width: auto;
  height: min(78vh, 640px);
  aspect-ratio: 33 / 48;
}

/* Fill button — overlaid on bottom of cover page */
.cover-fill-btn {
  position: absolute;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(239, 109, 73, 0.9);
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 700;
  font-family: 'Montserrat', Arial, sans-serif;
  cursor: pointer;
  z-index: 8;
  white-space: nowrap;
  transition: background 0.15s;
}

.cover-fill-btn:hover { background: #2d3748; }

/* Larger QR for big preview */
.cover-qr-area.large { bottom: 50px; gap: 5px; }
.cover-qr-box.large  { width: 64px; height: 64px; }

/* Cover hint text */
.cover-hint-text {
  font-size: 12px;
  color: #738194;
  font-family: 'Montserrat', Arial, sans-serif;
  margin: 0;
  line-height: 1.4;
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .cover-editor-v2 { flex-direction: column; }
  .cover-controls-panel { width: 100%; max-height: none; }
  .cover-controls-tabbed { flex-direction: column; }
  .cover-rail {
    flex-direction: row;
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #d9e1ea;
  }
  .cover-panel-body { max-height: none; }
  .cover-preview-panel { align-items: center; }
  .cover-page { width: 165px; height: 237px; }
  .cover-title-overlay { bottom: 40px; }
  .cover-year-overlay { bottom: 18px; }
  .cover-qr-area { bottom: 18px; }
}

@media (max-width: 560px) {
  .cover-page { width: 135px; height: 194px; }
  .cover-title-overlay { bottom: 32px; }
  .cover-year-overlay { bottom: 14px; }
}

/* ── Mobile: cover spread fills width (side by side) ── */
@media (max-width: 1100px) {
  .cover-spread-large {
    width: 100%;
  }

  .cover-page-wrap {
    width: calc(50% - 18px);
  }

  /* Shpina në mobil: gjerësia/lartësia/hendeku i sipërm llogariten tani
     me JS (spineTopOffset/spineHeight, CoverEditor.js) sipas madhësisë
     reale të faqes në çdo gjerësi ekrani — s'ka nevojë për vlera fikse
     këtu që të bien ndesh me matjen dinamike. */

  .cover-page.large {
    width: 100%;
    height: auto;
    aspect-ratio: 33 / 48;
  }
}

@media (max-width: 680px) {
  .cover-preview-stage {
    padding: 12px 8px;
    gap: 10px;
  }

  .cover-preview-note {
    font-size: 10px;
  }

  /* Cover controls on mobile: 2 columns */
  .cover-controls-panel {
    width: 100%;
  }

  .cover-layout-btns {
    grid-template-columns: 1fr 1fr;
  }
}

/* ── Back cover website URL ── */
.cover-back-url {
  position: absolute;
  bottom: 6%;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 9px;
  color: rgba(249, 110, 244, 0.85);
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.06em;
  z-index: 5;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/PhotoBook/CoverEditor.css"],"names":[],"mappings":"AAAA;;iDAEiD;AACjD;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;0EAC0E;AAC1E;EACE,mBAAmB;EACnB,MAAM;EACN,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,yCAAyC;AAC3C;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,yBAAyB,mBAAmB,EAAE,WAAW,EAAE;;AAE3D,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE,oBAAoB,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;;AAE7F;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gDAAgD;AAClD;AACA,2BAA2B,mBAAmB,EAAE;AAChD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA,wBAAwB,qBAAqB,EAAE;;AAE/C;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B,iBAAiB,EAAE,qBAAqB,EAAE;;AAEtE,mBAAmB,SAAO,EAAE;;AAE5B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;IAEI,wBAAwB,qBAAqB,EAAE;;AAEnD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;AAClD;;AAEA,0BAA0B,qBAAqB,EAAE,mBAAmB,EAAE;;AAEtE;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA,gCAAgC,cAAc,EAAE,gBAAgB,EAAE;;AAElE;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE;;;;8EAI4E;AAC9E;;AAEA;mCACmC,aAAa,EAAE;;AAElD,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,0BAA0B,qBAAqB,EAAE,2BAA2B,EAAE;;AAE9E,8BAA8B,cAAc,EAAE;AAC9C,oCAAoC,qBAAqB,EAAE,cAAc,EAAE;;AAE3E,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEvE;;iDAEiD;AACjD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gEAAgE;;AAEhE;2EAC2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;;wDAEsD;EACtD,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,YAAY,EAAE,6EAA6E;AAC7F;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,iFAAiF;EACjF,gBAAgB;AAClB;;AAEA;2EAC2E;AAC3E;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,0BAA0B,QAAQ,EAAE;AACpC,0BAA0B,QAAQ,EAAE;;AAEpC;;;6DAG6D;AAC7D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;;AAGA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;EAC1C,WAAW;EACX,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,QAAQ;AACV;;AAEA,4DAA4D;AAC5D;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA,iBAAiB,UAAU,EAAE,WAAW,EAAE,eAAe,EAAE;;AAE3D,aAAa,mBAAmB,EAAE;AAClC,eAAe,cAAc,EAAE,eAAe,EAAE;AAChD,qBAAqB,gBAAgB,EAAE;AACvC,eAAe,cAAc,EAAE;AAC/B,qBAAqB,mBAAmB,EAAE;;AAE1C,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA,+BAA+B,qCAAqC,EAAE;;AAEtE,sFAAsF;AACtF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA,oCAAoC,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;AACrF,oCAAoC,cAAc,EAAE,cAAc,EAAE,gBAAgB,EAAE,4CAA4C,EAAE;;AAEpI,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB;;;0BAGwB;AAC1B;;;AAGA;EACE,cAAc;EACd,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,4CAA4C;EAC5C,UAAU;EACV,4BAA4B;AAC9B;;AAEA,2BAA2B,qCAAqC,EAAE;AAClE,sCAAsC,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;AACvF,qCAAqC,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,4CAA4C,EAAE;;AAEtI,gCAAgC;AAChC,mCAAmC,YAAY,EAAE;AACjD,mCAAmC,WAAW,EAAE,YAAY,EAAE;;AAE9D,kCAAkC;AAClC;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,6CAA6C;EAC7C,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE;;WAES;EACT,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA,2BAA2B,YAAY,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC3E,2BAA2B,SAAS,EAAE,UAAU,EAAE,mBAAmB,EAAE;AACvE,2BAA2B,SAAS,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACxE,2BAA2B,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE;;AAE1E,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;EAClB,SAAS;AACX;;AAEA;;gDAEgD;AAChD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,wBAAwB,mBAAmB,EAAE;;AAE7C,8BAA8B;AAC9B,uBAAuB,YAAY,EAAE,QAAQ,EAAE;AAC/C,uBAAuB,WAAW,EAAE,YAAY,EAAE;;AAElD,oBAAoB;AACpB;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB,sBAAsB,EAAE;EAC3C,wBAAwB,WAAW,EAAE,gBAAgB,EAAE;EACvD,yBAAyB,sBAAsB,EAAE;EACjD;IACE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;EAClC;EACA,oBAAoB,gBAAgB,EAAE;EACtC,uBAAuB,mBAAmB,EAAE;EAC5C,cAAc,YAAY,EAAE,aAAa,EAAE;EAC3C,uBAAuB,YAAY,EAAE;EACrC,sBAAsB,YAAY,EAAE;EACpC,iBAAiB,YAAY,EAAE;AACjC;;AAEA;EACE,cAAc,YAAY,EAAE,aAAa,EAAE;EAC3C,uBAAuB,YAAY,EAAE;EACrC,sBAAsB,YAAY,EAAE;AACtC;;AAEA,0DAA0D;AAC1D;EACE;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;gDAG8C;;EAE9C;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,4CAA4C;EAC5C,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":["/* ═══════════════════════════════════════════════\n   Cover Editor V2\n═══════════════════════════════════════════════ */\n.cover-editor-v2 {\n  display: flex;\n  gap: 24px;\n  width: 100%;\n  min-height: 520px;\n  align-items: flex-start;\n}\n\n/* ── Left controls panel ── */\n.cover-controls-panel {\n  width: 272px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 700px;\n  overflow-y: auto;\n  padding-right: 2px;\n}\n\n.cover-section {\n  background: #f8fafc;\n  border: 1px solid #d9e1ea;\n  border-radius: 16px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.cover-section-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: #738194;\n  font-weight: 800;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n/* ── Rail + single-open-panel layout (replaces the old all-sections-stacked\n   layout) - one of Text/Layout/Stickers open at a time, like Pixory. ── */\n.cover-controls-tabbed {\n  flex-direction: row;\n  gap: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.cover-rail {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 60px;\n  flex-shrink: 0;\n  padding: 10px 6px;\n  border-right: 1px solid #d9e1ea;\n  background: #f8fafc;\n}\n\n.cover-rail-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  background: none;\n  border: none;\n  border-radius: 10px;\n  padding: 8px 2px;\n  cursor: pointer;\n  color: #738194;\n  font-family: 'Montserrat', Arial, sans-serif;\n  transition: background 0.15s, color 0.15s;\n}\n.cover-rail-btn:hover { background: #eef2f7; }\n.cover-rail-btn.active { background: #2d3748; color: #fff; }\n\n.cover-rail-icon { font-size: 16px; font-weight: 700; line-height: 1; }\n.cover-rail-label { font-size: 9px; font-weight: 700; text-align: center; line-height: 1.15; }\n\n.cover-panel-body {\n  flex: 1;\n  min-width: 0;\n  padding: 14px;\n  overflow-y: auto;\n  max-height: 700px;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n/* ── Stickers panel (in CoverControls) ── */\n.cover-sticker-cats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cover-sticker-cat {\n  background: #fff;\n  border: 1px solid #d9e1ea;\n  border-radius: 999px;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #445064;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n.cover-sticker-cat:hover { background: #eef2f7; }\n.cover-sticker-cat.active {\n  background: #2d3748;\n  border-color: #2d3748;\n  color: #fff;\n}\n\n.cover-stickers-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 6px;\n}\n\n.cover-sticker-thumb {\n  aspect-ratio: 1;\n  background: #fff;\n  border: 1px solid #d9e1ea;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n.cover-sticker-thumb:hover {\n  border-color: #ef6d49;\n  background: #fff7f4;\n}\n.cover-sticker-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  pointer-events: none;\n}\n\n/* ── Mode buttons ── */\n.cover-mode-list {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.cover-mode-btn {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  padding: 11px 13px;\n  background: #fff;\n  border: 1px solid #c8d2dd;\n  border-radius: 12px;\n  color: #233042;\n  font-size: 13.5px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.18s, background 0.18s;\n  line-height: 1.2;\n}\n\n.cover-mode-btn:hover { border-color: #2d3748; }\n\n.cover-mode-btn.active {\n  border-color: #2d3748;\n  background: #ffffff;\n  color: #2d3748;\n  font-weight: 700;\n}\n\n.cover-mode-btn.has-badge { padding-top: 17px; align-items: flex-end; }\n\n.cover-btn-label { flex: 1; }\n\n.cover-mode-badge {\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #d92d20;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n/* ── Form fields ── */\n.cover-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cover-field label {\n  font-size: 11.5px;\n  color: #738194;\n  font-weight: 600;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.cover-field input[type=\"text\"],\n.cover-field select {\n  padding: 8px 11px;\n  border: 1px solid #c8d2dd;\n  border-radius: 10px;\n  font-size: 13px;\n  color: #233042;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.18s;\n}\n\n.cover-field input[type=\"text\"]:focus,\n.cover-field select:focus {\n  border-color: #2d3748;\n  box-shadow: 0 0 0 3px rgba(45, 55, 72, 0.1);\n}\n\n.cover-field input[type=\"range\"] {\n  width: 100%;\n  accent-color: #2d3748;\n  cursor: pointer;\n  margin-top: 1px;\n}\n\n.cover-color-row {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.cover-color-row input[type=\"color\"] {\n  width: 36px;\n  height: 34px;\n  padding: 2px;\n  border: 1px solid #c8d2dd;\n  border-radius: 9px;\n  cursor: pointer;\n  background: #fff;\n}\n\n.cover-color-hex {\n  font-size: 11px;\n  color: #738194;\n  font-family: monospace;\n}\n\n/* ── Side tabs (Para / Mbrapa) ── */\n.cover-side-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n}\n\n.cover-side-tab {\n  padding: 9px 10px;\n  background: #fff;\n  border: 1px solid #c8d2dd;\n  border-radius: 10px;\n  color: #233042;\n  font-size: 13px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  cursor: pointer;\n  text-align: center;\n  transition: border-color 0.18s, background 0.18s;\n}\n\n    .cover-side-tab:hover { border-color: #2d3748; }\n\n.cover-side-tab.active {\n  border-color: #2d3748;\n  background: #ffffff;\n  color: #2d3748;\n  font-weight: 700;\n}\n\n/* ── Layout buttons (1 foto / 4 foto) ── */\n.cover-layout-btns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 7px;\n}\n\n.cover-layout-btn {\n  border: 1px solid #c8d2dd;\n  background: #fff;\n  border-radius: 12px;\n  padding: 10px 8px;\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  transition: border-color 0.18s, background 0.18s;\n}\n\n.cover-layout-btn:hover { border-color: #2d3748; background: #dfdfdf; }\n\n.cover-layout-btn.active {\n  border-color: #2d3748;\n  background: #ffffff;\n}\n\n.cover-layout-btn span {\n  font-size: 12px;\n  color: #233042;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.cover-layout-btn.active span { color: #2d3748; font-weight: 700; }\n\n.layout-icon-box {\n  width: 44px;\n  height: 44px;\n  border: 1px solid rgba(35, 48, 66, 0.14);\n  border-radius: 9px;\n  background: #f3f6f9;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Full = single block */\n.layout-icon-preview.full {\n  width: 30px;\n  height: 30px;\n  background: rgba(35, 48, 66, 0.2);\n  border-radius: 3px;\n}\n\n/* Grid = 2×2 */\n.layout-icon-preview.grid {\n  width: 30px;\n  height: 30px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  gap: 2px;\n}\n\n.layout-icon-preview.grid::before,\n.layout-icon-preview.grid::after {\n  content: '';\n  display: block;\n  background: rgba(35, 48, 66, 0.2);\n  border-radius: 2px;\n}\n\n/* Extra 2 cells for grid via box-shadow trick */\n.layout-icon-preview.grid {\n  background:\n    linear-gradient(rgba(35,48,66,0.2) 0 100%) 0 0 / 13px 13px no-repeat,\n    linear-gradient(rgba(35,48,66,0.2) 0 100%) 16px 0 / 13px 13px no-repeat,\n    linear-gradient(rgba(35,48,66,0.2) 0 100%) 0 16px / 13px 13px no-repeat,\n    linear-gradient(rgba(35,48,66,0.2) 0 100%) 16px 16px / 13px 13px no-repeat;\n}\n\n.layout-icon-preview.grid::before,\n.layout-icon-preview.grid::after { display: none; }\n\n/* Full-bleed icon = full block filling the icon box */\n.layout-icon-preview.full-bleed {\n  width: 38px;\n  height: 38px;\n  background: rgba(35, 48, 66, 0.2);\n  border-radius: 2px;\n}\n\n/* ── Action buttons ── */\n.cover-action-btn {\n  width: 100%;\n  padding: 10px 13px;\n  background: #fff;\n  border: 1px solid #c8d2dd;\n  border-radius: 12px;\n  color: #233042;\n  font-size: 13px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.18s, transform 0.12s;\n}\n\n.cover-action-btn:hover { border-color: #2d3748; transform: translateY(-1px); }\n\n.cover-action-btn.secondary { color: #738194; }\n.cover-action-btn.secondary:hover { border-color: #2d3748; color: #2d3748; }\n\n.cover-upload-group { display: flex; flex-direction: column; gap: 7px; }\n\n/* ═══════════════════════════════════════════════\n   Right preview panel\n═══════════════════════════════════════════════ */\n.cover-preview-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  min-width: 0;\n  padding: 10px 0;\n}\n\n.cover-spread-wrap {\n  display: flex;\n  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.14);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n/* Cover page — 33:48 ratio ≈ 220×315 */\n.cover-page {\n  position: relative;\n  width: 220px;\n  height: 315px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n/* Wrapper që mban barin e jashtëm + cover page bashkë */\n.cover-page-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n/* .cover-back { border-right: 2px solid rgba(0, 0, 0, 0.1); } */\n\n/* ── Shpina (mes kopertinës së pasme dhe të përparme) — vetëm pamje\n   paraprake, shih shënimin te CoverEditor.js pranë renderimit të saj. ── */\n.cover-spine-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* Pa gap: spineTopOffset (matur me JS) është VETË distanca e plotë\n     deri te maja e faqes — nëse shtojmë edhe gap këtu, e dyfishojmë\n     boshllëkun dhe shpina bie 6px më poshtë se faqet. */\n  gap: 0;\n  flex-shrink: 0;\n}\n\n.cover-spine-bar-spacer {\n  height: 34px; /* fallback derisa CoverEditor.js ta llogarisë saktë me JS (ResizeObserver) */\n}\n\n.cover-spine {\n  position: relative;\n  width: 18px;\n  height: min(65vh, 520px);\n  box-shadow: inset 2px 0 0 rgba(0, 0, 0, 0.06), inset -2px 0 0 rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n/* Dy tekste të pavarura në shpinë — titulli afër majës, data afër fundit —\n   të dyja vertikale (rrotulluar), të centruara horizontalisht në shirit. */\n.cover-spine-text {\n  position: absolute;\n  left: 50%;\n  display: inline-block;\n  white-space: nowrap;\n  transform: translate(-50%, -50%) rotate(90deg);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cover-spine-text-title { top: 12%; }\n.cover-spine-text-date  { top: 88%; }\n\n/* Spine sticker: single static slot (no drag/resize) - click to add (empty\n   dashed placeholder) or click again to remove (the placed icon itself is\n   the delete affordance, since .cover-spine's `overflow: hidden` at ~16px\n   wide leaves no room for a separate corner delete badge). */\n.cover-spine-sticker {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 4;\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  border-radius: 2px;\n  transition: opacity 0.15s, outline 0.15s;\n  outline: 1.5px solid transparent;\n  outline-offset: 1px;\n}\n.cover-spine-sticker:hover {\n  opacity: 0.55;\n  outline-color: #e53e3e;\n}\n\n.cover-spine-sticker img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  pointer-events: none;\n}\n\n.cover-spine-sticker-add {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px dashed #b7c1cd;\n  border-radius: 3px;\n  background: rgba(255, 255, 255, 0.6);\n  color: #738194;\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n  z-index: 4;\n}\n.cover-spine-sticker-add:hover {\n  border-color: #ef6d49;\n  color: #ef6d49;\n  background: #fff;\n}\n\n.cover-spine-note {\n  font-size: 11px;\n  color: #9aa5b1;\n  margin: 2px 0 0;\n  line-height: 1.4;\n}\n\n.cover-full-img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  z-index: 1;\n}\n\n/* ─── Photo area container ─── */\n.cover-photo-area {\n  position: absolute;\n  overflow: hidden;\n  z-index: 2;\n}\n\n/* Single photo: rectangle in upper portion */\n.cover-photo-area.full {\n  top: 5%;\n  left: 6%;\n  right: 6%;\n  height: 60%;\n}\n\n/* Full-bleed: photo covers entire cover page */\n.cover-photo-area.full-bleed {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n}\n\n/* 4-photo grid: same zone as single photo, 2x2 layout */\n.cover-photo-area.grid-4 {\n  top: 5%;\n  left: 6%;\n  right: 6%;\n  height: 60%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  gap: 8px;\n}\n\n/* Grid-4 cells */\n.cover-photo-area.grid-4 .csw-content {\n  border-radius: 3px;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n/* Photos fit fully — no cropping, no auto-zoom */\n.cover-photo-area.grid-4 .csw-img {\n  object-fit: contain;\n}\n\n/* ─── CoverPhotoSlot (csw = cover slot wrap) ─────────────────────────────── */\n.csw {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n}\n\n\n/* Control bar — brenda slot (vetëm mini/grid-4) */\n.csb-bar {\n  position: absolute;\n  top: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  background: rgba(255, 255, 255, 0.92);\n  border-radius: 999px;\n  padding: 4px 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);\n  z-index: 20;\n  white-space: nowrap;\n}\n\n/* Bar i jashtëm — sipër cover page, jo brenda */\n.csb-bar-external {\n  position: static;\n  transform: none;\n  top: auto;\n  left: auto;\n}\n\n.csw-mini .csb-bar {\n  top: 4px;\n  padding: 3px 7px;\n  gap: 1px;\n}\n\n/* Mini delete-only bar: small × badge in top-right corner */\n.csb-bar.csb-bar-mini-del {\n  top: 4px;\n  right: 4px;\n  left: auto;\n  transform: none;\n  padding: 2px 6px;\n  background: rgba(255, 255, 255, 0.88);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n\n.csb {\n  width: 26px;\n  height: 26px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  color: #233042;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.12s;\n  padding: 0;\n}\n\n.csw-mini .csb { width: 0px; height: 2px; font-size: 11px; }\n\n.csb:hover { background: #f0f2f5; }\n.csb.csb-dis { color: #c0cad5; cursor: default; }\n.csb.csb-dis:hover { background: none; }\n.csb.csb-del { color: #e53e3e; }\n.csb.csb-del:hover { background: #fff5f5; }\n\n/* Slot content area */\n.csw-content {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 4px;\n  position: relative;\n}\n\n\n.csw-content.csw-empty {\n  border: 1.5px dashed rgba(202, 202, 202, 0.281);\n  background: rgba(202, 202, 202, 0.622);\n  transition: background 0.15s;\n}\n\n.csw-content.csw-empty:hover { background: rgba(202, 202, 202, 0.12); }\n\n/* Image inside slot — absolutely fills the container so % height resolves correctly */\n.csw-img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transform-origin: center center;\n  user-select: none;\n  pointer-events: none;\n}\n\n/* Grid-4 photos: show full image without any cropping */\n.cover-photo-area.grid-4 .csw-img {\n  object-fit: contain;\n}\n\n/* Empty placeholder text */\n.csw-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  pointer-events: none;\n}\n\n.csw-placeholder span:first-child { font-size: 22px; color: #ffffff; line-height: 1; }\n.csw-placeholder span:last-child  { font-size: 7px; color: #ffffff; font-weight: 600; font-family: 'Montserrat', Arial, sans-serif; }\n\n/* ── QR area ── */\n.cover-qr-area {\n  position: absolute;\n  bottom: 26px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  z-index: 4;\n}\n\n.cover-qr-box {\n  width: 46px;\n  height: 46px;\n  border: 1.5px solid rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  background:\n    repeating-linear-gradient(0deg, rgba(0,0,0,0.14) 0px, rgba(0,0,0,0.14) 3px, transparent 3px, transparent 6px),\n    repeating-linear-gradient(90deg, rgba(0,0,0,0.14) 0px, rgba(0,0,0,0.14) 3px, transparent 3px, transparent 6px),\n    rgba(255,255,255,0.95);\n}\n\n\n.cover-qr-label {\n  font-size: 8px;\n  color: rgba(0, 0, 0, 0.4);\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* ── Upload hint ── */\n.cover-upload-hint {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n  background: rgba(198, 198, 198, 0.14);\n  border: 2px dashed rgba(198, 198, 198, 0.14);\n  z-index: 3;\n  transition: background 0.18s;\n}\n\n.cover-upload-hint:hover { background: rgba(198, 198, 198, 0.14); }\n.cover-upload-hint span:first-child { font-size: 26px; color: #2d3748; line-height: 1; }\n.cover-upload-hint span:last-child { font-size: 11px; color: #2d3748; font-weight: 700; font-family: 'Montserrat', Arial, sans-serif; }\n\n/* ─── Large QR adjustment ─── */\n.cover-page.large .cover-qr-area { bottom: 60px; }\n.cover-page.large .cover-qr-box  { width: 60px; height: 60px; }\n\n/* ── Draggable text overlays ── */\n.cover-drag-text {\n  z-index: 5;\n  cursor: grab;\n  user-select: none;\n  -webkit-user-select: none;\n  padding: 3px 6px;\n  border-radius: 3px;\n  transition: outline 0.15s;\n  text-align: center;\n}\n\n.cover-drag-text:hover {\n  outline: 1.5px dashed rgba(239, 109, 73, 0.6);\n  outline-offset: 3px;\n}\n\n.cover-drag-text:active {\n  cursor: grabbing;\n  outline: 1.5px solid #2d3748;\n}\n\n.cover-drag-text-input {\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  outline: 1.5px dashed rgba(239, 109, 73, 0.9);\n  outline-offset: 3px;\n  cursor: text;\n}\n\n/* ── Sticker overlays ── */\n.cover-sticker {\n  position: absolute;\n  z-index: 6;\n  cursor: grab;\n  outline: 1.5px dashed transparent;\n  outline-offset: 2px;\n  transition: outline 0.15s;\n}\n\n.cover-sticker:hover {\n  outline-color: rgba(239, 109, 73, 0.6);\n}\n\n.cover-sticker:active {\n  cursor: grabbing;\n}\n\n.cover-sticker img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n  pointer-events: none;\n  user-select: none;\n}\n\n.cover-sticker-del {\n  /* Top-CENTER, not a corner - all 4 corners are resize handles now, and\n     top-right overlapped/blocked this button's clicks when it lived there\n     too. */\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 20px;\n  height: 20px;\n  font-size: 11px;\n  z-index: 8;\n}\n\n.cover-sticker-handle {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  background: #fff;\n  border: 1.5px solid #2d3748;\n  cursor: nwse-resize;\n  z-index: 7;\n}\n\n.cover-sticker-handle-br { bottom: -6px; right: -6px; cursor: nwse-resize; }\n.cover-sticker-handle-tl { top: -6px; left: -6px; cursor: nwse-resize; }\n.cover-sticker-handle-tr { top: -6px; right: -6px; cursor: nesw-resize; }\n.cover-sticker-handle-bl { bottom: -6px; left: -6px; cursor: nesw-resize; }\n\n/* ── Page tag ── */\n.cover-page-tag {\n  position: absolute;\n  bottom: 5px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0,0,0,0.48);\n  color: #fff;\n  font-size: 8.5px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  white-space: nowrap;\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.cover-preview-note {\n  font-size: 11.5px;\n  color: #8fa0b4;\n  font-family: 'Montserrat', Arial, sans-serif;\n  text-align: center;\n  margin: 0;\n}\n\n/* ══════════════════════════════════════════════\n   Large (stage) cover preview\n══════════════════════════════════════════════ */\n.cover-preview-stage {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n  width: 100%;\n  padding: 16px 12px;\n}\n\n/* ── Popup udhëzues (një herë, kur klienti hyn te redaktimi i kopertinës) ── */\n.cover-intro-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(20, 20, 25, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 60;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.cover-intro-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 20px 22px;\n  max-width: 320px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n  text-align: left;\n}\n\n.cover-intro-card h4 {\n  margin: 0 0 8px;\n  font-size: 15px;\n  color: #233042;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.cover-intro-card p {\n  margin: 0 0 16px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #5b6774;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.cover-intro-close {\n  width: 100%;\n  padding: 10px 12px;\n  background: #2d3748;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  font-family: 'Montserrat', Arial, sans-serif;\n  cursor: pointer;\n}\n\n.cover-intro-close:hover { background: #1a202c; }\n\n.cover-spread-large {\n  display: flex;\n  flex-direction: row;\n  gap: 1px;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/* Large cover page: scales with viewport */\n.cover-page.large {\n  width: auto;\n  height: min(78vh, 640px);\n  aspect-ratio: 33 / 48;\n}\n\n/* Fill button — overlaid on bottom of cover page */\n.cover-fill-btn {\n  position: absolute;\n  bottom: 28px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(239, 109, 73, 0.9);\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 11px;\n  font-weight: 700;\n  font-family: 'Montserrat', Arial, sans-serif;\n  cursor: pointer;\n  z-index: 8;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n\n.cover-fill-btn:hover { background: #2d3748; }\n\n/* Larger QR for big preview */\n.cover-qr-area.large { bottom: 50px; gap: 5px; }\n.cover-qr-box.large  { width: 64px; height: 64px; }\n\n/* Cover hint text */\n.cover-hint-text {\n  font-size: 12px;\n  color: #738194;\n  font-family: 'Montserrat', Arial, sans-serif;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* ── Responsive ── */\n@media (max-width: 900px) {\n  .cover-editor-v2 { flex-direction: column; }\n  .cover-controls-panel { width: 100%; max-height: none; }\n  .cover-controls-tabbed { flex-direction: column; }\n  .cover-rail {\n    flex-direction: row;\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid #d9e1ea;\n  }\n  .cover-panel-body { max-height: none; }\n  .cover-preview-panel { align-items: center; }\n  .cover-page { width: 165px; height: 237px; }\n  .cover-title-overlay { bottom: 40px; }\n  .cover-year-overlay { bottom: 18px; }\n  .cover-qr-area { bottom: 18px; }\n}\n\n@media (max-width: 560px) {\n  .cover-page { width: 135px; height: 194px; }\n  .cover-title-overlay { bottom: 32px; }\n  .cover-year-overlay { bottom: 14px; }\n}\n\n/* ── Mobile: cover spread fills width (side by side) ── */\n@media (max-width: 1100px) {\n  .cover-spread-large {\n    width: 100%;\n  }\n\n  .cover-page-wrap {\n    width: calc(50% - 18px);\n  }\n\n  /* Shpina në mobil: gjerësia/lartësia/hendeku i sipërm llogariten tani\n     me JS (spineTopOffset/spineHeight, CoverEditor.js) sipas madhësisë\n     reale të faqes në çdo gjerësi ekrani — s'ka nevojë për vlera fikse\n     këtu që të bien ndesh me matjen dinamike. */\n\n  .cover-page.large {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 33 / 48;\n  }\n}\n\n@media (max-width: 680px) {\n  .cover-preview-stage {\n    padding: 12px 8px;\n    gap: 10px;\n  }\n\n  .cover-preview-note {\n    font-size: 10px;\n  }\n\n  /* Cover controls on mobile: 2 columns */\n  .cover-controls-panel {\n    width: 100%;\n  }\n\n  .cover-layout-btns {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* ── Back cover website URL ── */\n.cover-back-url {\n  position: absolute;\n  bottom: 6%;\n  left: 0;\n  right: 0;\n  text-align: center;\n  font-size: 9px;\n  color: rgba(249, 110, 244, 0.85);\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  z-index: 5;\n  pointer-events: none;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
